import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import LoaderRounded from './LoaderRounded';

class ScannerPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionData: null,
            selectedBenefits: [],
            isloader: false,
        };
    }

    componentDidMount() {
        const scannedData = this.props.result;

        if (!scannedData?.yinId) {
            alert("Invalid QR code scanned!");
            this.props.onPopupCloseMain();
            return;
        }

        const payload = { yin_id: scannedData.yinId, mobile: "", isSubscription: true };

        axios.post(`${process.env.REACT_APP_APIURL}/subscription/read`, payload)
            .then(res => {
                if (res.data.data && res.data.data.length > 0) {
                    this.setState({ subscriptionData: res.data.data[0] });
                } else {
                    alert("No subscription data found!");
                    this.props.onPopupCloseMain();
                }
            })
            .catch(err => {
                console.error(err);
                this.props.onPopupCloseMain();
            });
    }


    handleBenefitChange = (e) => {
        let { selectedBenefits } = this.state;
        if (e.target.checked) {
            selectedBenefits.push(e.target.value);
        } else {
            selectedBenefits = selectedBenefits.filter(item => item !== e.target.value);
        }
        this.setState({ selectedBenefits });
    };

    // submit reward
    submitRewards = async () => {
        const scannedData = this.props.result;
        const data = {
            yinId: scannedData?.yinId,
            rewardType: this.state.selectedBenefits.map(item => item.toLowerCase()),
        };

        try {
            this.setState({ isloader: true });

            const response = await axios.post(
                process.env.REACT_APP_APIURL + `/qrsub/scanQRCode`,
                data,
                {
                    validateStatus: (status) => {
                        return status === 200 || status === 606;
                    },
                }
            );

            if (response.status === 200) {
                alert("Reward submitted successfully!");
                window.location.href = '/list/scanner';
            } else if (response.status === 606) {
                alert(response.data.message);
            } else {
                alert(response.Message);
            }
        } catch (error) {
            console.error("Error while submitting reward:", error);
            alert("Failed to submit reward");
        } finally {
            this.setState({ isloader: false, selectedBenefits: [] });
        }
    };

    render() {
        const { showModalPopup, onPopupCloseMain } = this.props;
        const { subscriptionData } = this.state;

        return (
            <Modal show={showModalPopup} onHide={onPopupCloseMain} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Membership Benefits</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {!subscriptionData ? (
                        <div className="text-center">Loading...</div>
                    ) : (
                        <>
                            {subscriptionData?.claimedRewards &&
                                Object.values(subscriptionData.claimedRewards).every(val => val === true) ? (
                                <div className="alert alert-success text-center fw-bold" role="alert">
                                    🎉 You have received all your goodies!
                                </div>
                            ) : (
                                <div className="row">
                                    {/* Bag */}
                                    <div className="col d-flex align-items-center">
                                        {subscriptionData?.claimedRewards?.bag ? (
                                            <span style={{ color: "green", fontWeight: "600" }}>✅ Bag</span>
                                        ) : (
                                            <>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    value="Bag"
                                                    onChange={this.handleBenefitChange}
                                                />
                                                <label>Bag</label>
                                            </>
                                        )}
                                    </div>

                                    {/* Bottle */}
                                    <div className="col d-flex align-items-center">
                                        {subscriptionData?.claimedRewards?.bottle ? (
                                            <span style={{ color: "green", fontWeight: "600" }}>✅ Bottle</span>
                                        ) : (
                                            <>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    value="Bottle"
                                                    onChange={this.handleBenefitChange}
                                                />
                                                <label>Bottle</label>
                                            </>
                                        )}
                                    </div>

                                    {/* Kit */}
                                    <div className="col d-flex align-items-center">
                                        {subscriptionData?.claimedRewards?.kit ? (
                                            <span style={{ color: "green", fontWeight: "600" }}>✅ Kit</span>
                                        ) : (
                                            <>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    value="Kit"
                                                    onChange={this.handleBenefitChange}
                                                />
                                                <label>Kit</label>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onPopupCloseMain}>
                        Close
                    </Button>
                    {subscriptionData?.claimedRewards &&
                        !Object.values(subscriptionData.claimedRewards).every(val => val === true) && (
                            <Button
                                variant="primary"
                                disabled={this.state.selectedBenefits.length === 0}
                                onClick={this.submitRewards}
                            >
                                {this.state.isloader ? <LoaderRounded /> : "Submit"}
                            </Button>
                        )}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(ScannerPopup);

